import axios from 'axios';
import { API_BASE_URL } from '../config/api';
import { Encrypt } from '../pages/encryption/payload-encryption';

// Public: Validate QR Code on scan
export const validateQRCode = async (qr_id) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/qrcode/validate/${qr_id}`);
        return response.data;
    } catch (error) {
        console.error('Error validating QR code:', error);
        return { error: 'Failed to validate QR code. Please try again.' };
    }
};

// Public: Process Scan Action (register / login / auto-map / open chatroom)
export const processScanAction = async (payload) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/qrcode/scan-action`, payload, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return response.data;
    } catch (error) {
        console.error('Error processing scan action:', error);
        return { error: 'Network error processing QR code action' };
    }
};

// Authenticated (Read-Only): View QR codes generated by Admin for this project
export const getProjectQRCodes = async ({ project_id }) => {
    const getUserData = () => {
        try {
            const userData = localStorage.getItem('userData');
            return userData ? JSON.parse(userData) : null;
        } catch (error) {
            return null;
        }
    };

    const userData = getUserData();
    const token = userData?.token;
    const username = userData?.username;

    if (!token || !username) {
        throw new Error('Session expired');
    }

    const payload = { project_id };
    const { data, key } = Encrypt(payload);

    const config = {
        method: 'post',
        url: `${API_BASE_URL}/qrcode/list`,
        headers: {
            'Content-Type': 'application/json',
            token,
            username,
        },
        data: JSON.stringify({ data, key }),
    };

    const response = await axios.request(config);
    return response.data;
};
